import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"position":"relative"}},[_c('menu-or-bottom-sheet',{attrs:{"max-width":600},scopedSlots:_vm._u([{key:"trigger",fn:function({ on }){return [_c(VIcon,_vm._g({attrs:{"x-small":"","color":"deep-orange"}},on),[_vm._v("mdi-information-outline")])]}},{key:"content",fn:function(){return [_c('admin-user-stats-card',{attrs:{"user":_vm.user}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }